<vi-page [sidenavs]="true" [footer]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="legalInformation"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="legalInformation"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.LEGAL_INFORMATION' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>
  <vi-header head color="white">
    <div class="flex flex-col gap-[12px] flex-auto" data-at-bar-message>
      <h1 data-at-title>
        {{ '+LEGAL_INFORMATION.TITLE' | translate }}
      </h1>
    </div>
  </vi-header>

  <vi-content body>
    <div main>
      <mat-card class="box-shadow-1">
        <mat-card-header class="flex flex-row justify-between items-stretch">
          <mat-card-title class="title">{{
            '+LEGAL_INFORMATION.OPEN_SOURCE_LICENSES.TITLE' | translate
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul data-at-open-source-list class="columns">
            <li *ngFor="let item of openSources">
              <div class="open-source-item" data-at-open-source-item>
                <p data-at-open-source-item-name>{{ item.name }}</p>
                <a
                  class="link-focus"
                  data-at-open-source-item-url
                  href="{{ item.url }}"
                  gtm="onRedirect"
                  gtmAction="Open source software website"
                  gtmCategory="legalInformation"
                  gtmLabel="{{ item.url }}"
                  target="_blank"
                  >{{ item.url }}</a
                >
              </div>
            </li>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
